import { isArray, isObject } from "lodash";

import type { PropertyDto } from "../types";

export function recursivelyExtractValues(
  obj: unknown,
): (PropertyDto | string | boolean | number)[] {
  if (!obj || typeof obj !== "object") return [];
  return Object.values(obj).flatMap((value) =>
    isObject(value) || isArray(value)
      ? recursivelyExtractValues(value)
      : [value],
  );
}
